import { useEffect, useState } from "react";
import { api, EvidenceBadge } from "@/lib/api";

export default function Analytics() {
  const [summary, setSummary] = useState(null);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/analytics/summary").then((r) => setSummary(r.data));
    api.get("/analytics/posts").then((r) => setPosts(r.data));
  }, []);

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Analytics</div>
        <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Performance</h1>
        <p className="text-sm text-neutral-600 mt-2">Primary success: reach, shares, saves, followers gained, profile visits, website taps — not likes.</p>
      </div>

      {summary && !summary.has_data && (
        <div className="bg-white border border-neutral-200 border-dashed rounded-lg p-6 mb-6">
          <div className="font-semibold">Insufficient first-party data</div>
          <p className="text-sm text-neutral-600 mt-1">{summary.message}</p>
        </div>
      )}

      {summary?.has_data && (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
          <Metric label="Posts analysed" value={summary.post_count} />
          <Metric label="Avg reach" value={Math.round(summary.avg_reach || 0).toLocaleString()} />
          <Metric label="Best pillar" value={summary.best_pillar || "—"} small />
          <Metric label="Best format" value={summary.best_format || "—"} small />
        </div>
      )}

      <div className="bg-white border border-neutral-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 border-b border-neutral-200">
            <tr>
              <th className="text-left px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Date</th>
              <th className="text-left px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Hook</th>
              <th className="text-left px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Format</th>
              <th className="text-right px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Reach</th>
              <th className="text-right px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Shares</th>
              <th className="text-right px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Saves</th>
              <th className="text-right px-4 py-2 font-semibold text-xs uppercase tracking-widest text-neutral-500">Follows +</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((p) => (
              <tr key={p.id} className="border-b border-neutral-100" data-testid={`analytics-row-${p.id}`}>
                <td className="px-4 py-2 text-neutral-600">{p.publish_date}</td>
                <td className="px-4 py-2 truncate max-w-xs">{p.hook}</td>
                <td className="px-4 py-2 text-neutral-600">{p.format}</td>
                <td className="px-4 py-2 text-right">{p.metrics?.reach?.toLocaleString() || "—"}</td>
                <td className="px-4 py-2 text-right">{p.metrics?.shares ?? "—"}</td>
                <td className="px-4 py-2 text-right">{p.metrics?.saves ?? "—"}</td>
                <td className="px-4 py-2 text-right">{p.metrics?.followers_gained ?? "—"}</td>
              </tr>
            ))}
            {posts.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-neutral-500 text-sm">No published posts yet. Import CSV.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Metric({ label, value, small }) {
  return (
    <div className="bg-white border border-neutral-200 rounded-lg p-6">
      <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">{label}</div>
      <div className={`${small ? "text-2xl" : "text-4xl"} font-black tracking-tighter mt-2`} style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>{value}</div>
    </div>
  );
}
